import React from "react";

// Importing icons
import hoursIconActive from "../../assets/icons/hours-active.svg";
import servicesIconActive from "../../assets/icons/services-active.svg";
import servicesIconInactive from "../../assets/icons/services-not-active.svg";
import courtsIconActive from "../../assets/icons/courts-active.svg";
import courtsIconInactive from "../../assets/icons/courts-not-active.svg";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const ClubInfoSteps = ({
  hoursActive = false,
  servicesActive = false,
  courtsActive = false,
  hoursBold = false,
  servicesBold = false,
  courtsBold = false,
}) => {
  const { Auth }: DictionaryType = useGetDictionary();
  const steps = [
    {
      id: 1,
      label: Auth?.opening_hours,
      icon: hoursIconActive,
      bold: hoursBold,
    },
    {
      id: 2,
      label: Auth?.services,
      icon: servicesActive ? servicesIconActive : servicesIconInactive,
      bold: servicesBold,
    },
    {
      id: 3,
      label: Auth?.courts,
      icon: courtsActive ? courtsIconActive : courtsIconInactive,
      bold: courtsBold,
    },
  ];

  return (
    <div className="relative w-[450px] mx-auto">
      <div className="absolute top-[34%] left-0 right-0 h-[2px] bg-gray-300 z-0"></div>

      <div className="flex items-center justify-between relative mx-auto max-w-[450px] z-10">
        {steps.map((step, index) => (
          <div
            key={index}
            className="text-center flex-col flex justify-center  "
          >
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center `}
            >
              <img loading="lazy" src={step.icon} alt={step.label} className="w-12 h-12" />
            </div>

            <p
              className={`mt-2 text-sm ${step.id === 1 ? "-ml-7" : ""}  ${
                step.bold
                  ? "font-bold text-primary dark:text-white"
                  : "font-normal text-gray-700"
              }`}
            >
              {step.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClubInfoSteps;
